module.exports = __webpack_public_path__ + "img/Tidak Bergerak.f1a191d7.svg";